<template>
  <div>
    <div class="floL">
      <label :for="`file${resIdx}_${question.sq_code}`">
        <em class="disIb">{{ question.title }}<span class="ico-must-astar"></span></em>
      </label>
      <input
        v-if="!existFileData"
        type="file"
        ref="attachment"
        accept=".png, .jpg, .pdf"
        :name="`file${resIdx}_${question.sq_code}`"
        :id="`file${resIdx}_${question.sq_code}`"
        style="display:none;"
        @change="uploadAttachment"
        :disabled="disabled"
      />
    </div>
    <div class="floR txtR">
      <div class="NCAcmi_familyN_fileWrap">
        <span
          class="fntP NCAcmi_familyN_file"
          :class="{ disabled: existFileData || disabled }"
          :style="{ cursor: existFileData || disabled ? 'default' : 'pointer' }"
          @click="clickUploadButton"
        >파일 업로드</span>
        <div class="posRe">
          <label
            class="NCAcmi_familyN_fileBox marTS NCAcmiFile_remove"
            @click="downloadFile"
          >
            <input
              type="text"
              :title="originalName"
              :value="originalName"
              :style="existFileData ? { cursor: 'pointer' } : null"
              disabled
            />
          </label>
          <button
            class="posAb"
            @click="deleteAttachment"
            style="right:0; top:6px; background:none;"
            :style="!existFileData || disabled ? { display: 'none' } : null"
          >
            <img src="../images/btn_close.png" alt="파일 삭제 버튼">
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AttachmentMixin } from '../mixins'

export default {
  name: 'SurveyAttachmentFamily',
  mixins: [AttachmentMixin]
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/survey2/components/SurveyAttachmentFamily.vue